import translate from '../../translate';
import { getCountryName, getBrandCountries, getDefaultCountry, getMapCountrySite } from '../../countries';
import { getGlobalEData, handleGlobalEBanner } from '../globalE';
const FORCED_CURRENCY_SYMBOLS = {
    AUD: 'AU$',
    CAD: 'CA$',
    HKD: 'HK$',
    NZD: 'NZ$',
    SGD: 'SG$',
    TWD: 'NT$',
    USD: 'US$',
    XCD: 'EC$',
};
export default async () => {
    const switchers = document.querySelectorAll('.c-header [data-switch-redirect]');
    if (!switchers.length)
        return;
    const globalEData = getGlobalEData();
    const defaultCountry = getDefaultCountry();
    if (!globalEData || !defaultCountry)
        return;
    const countries = getBrandCountries();
    const countryData = countries.find((c) => c.label === globalEData.countryISO);
    const mapCountrySite = getMapCountrySite();
    const countrySite = mapCountrySite[globalEData.countryISO];
    const countryFromSite = countryData && countrySite && window.location.pathname.startsWith(`/${countrySite}`);
    // @ts-ignore
    const globalECountries = window.globalECountries || [];
    // Display country code + currency symbol
    let countryCode;
    let currencySymbol;
    if (countryFromSite) {
        countryCode = countryData.label;
        const currencyCode = globalECountries.includes(countryData.label)
            ? globalEData.currencyCode
            : countryData.currencyCode;
        const forcedCurrencySymbol = FORCED_CURRENCY_SYMBOLS[currencyCode];
        if (forcedCurrencySymbol) {
            currencySymbol = forcedCurrencySymbol;
        }
        else {
            try {
                const formatter = new Intl.NumberFormat(document.documentElement.lang, {
                    style: 'currency',
                    currency: currencyCode,
                });
                const formattedNb = formatter.formatToParts(0);
                currencySymbol = formattedNb.find((part) => part.type === 'currency')?.value;
            }
            catch (e) {
                currencySymbol = currencyCode;
            }
        }
    }
    else {
        countryCode = defaultCountry.code;
        currencySymbol = FORCED_CURRENCY_SYMBOLS[defaultCountry.currencyCode] || defaultCountry.currencyLabel;
    }
    switchers.forEach(async (switcher) => {
        const countryNameEl = switcher.querySelector('[data-country-name]');
        if (countryNameEl) {
            countryNameEl.innerHTML = countryCode;
        }
        const currencyEl = switcher.querySelector('[data-currency]');
        if (currencyEl) {
            currencyEl.innerHTML = `(${currencySymbol})`;
        }
        // Switch action
        switcher.addEventListener('click', (e) => {
            e.stopPropagation();
            handleGlobalEBanner(true);
        });
        // Mobile country display
        const countryName = await getCountryName(countryCode);
        const countryNameMobileEl = switcher.querySelector('[data-country-name-mobile]');
        if (countryNameMobileEl) {
            countryNameMobileEl.innerHTML = translate('front.header.shipping_country', {
                country: countryName,
            });
        }
    });
};
